// extracted by mini-css-extract-plugin
module.exports = {"section":"_3ioOm","heading":"_1l-aJ"};